(() => {
  if (window.RPQuoteList) return;
  const KEY = 'rollerparts_quote_list_v1';
  const root = () => window.Shopify?.routes?.root || '/';
  const panel = () => document.querySelector('[data-rp-quote-panel-root]');
  const config = () => panel()?.dataset || {};
  let queue = Promise.resolve();
  let opener;
  let submitting = false;
  let step = 'items';
  let directItems = null;
  const activeItems = () => directItems === null ? read() : directItems;
  const keyFor = item => JSON.stringify([Number(item.variant_id || item.id), Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
  function read() {
    const items = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (!Array.isArray(items)) throw new Error(config().storageError);
    return items.map(item => {
      const id = Number(item.variant_id || item.id);
      const quantity = Number(item.quantity);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error(config().storageError);
      const properties = Object.fromEntries(Object.entries(item.properties || {}).filter(([k,v]) => typeof k === 'string' && typeof v === 'string'));
      return {...item, id, variant_id: id, quantity, properties};
    });
  }
  function error(message) {
    const el = panel()?.querySelector('[data-rp-list-error]');
    if (el) { el.textContent = message || config().error; el.hidden = false; }
  }
  function open(trigger) {
    const el = panel();
    if (!el) return;
    if (el.dataset.enquiryMode === 'single_product') { directItems = null; resetForm(); step = 'items'; }
    if (!el.open) opener = trigger || document.activeElement;
    draw();
    if (!el.open) el.showModal();
    document.documentElement.classList.add('rp-quote-drawer-open');
    loadRecommendations();
    document.querySelectorAll('[data-rp-quote-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
  }
  function openDirect(items, trigger) {
    directItems = null;
    open(trigger);
    resetForm();
    directItems = items;
    setStep('details');
    panel()?.querySelector('[name="full_name"], [data-rp-native-name]')?.focus({preventScroll:true});
  }
  async function writeActive(change) {
    if (directItems === null) return write(change);
    directItems = change(directItems.map(item => ({...item})));
    draw();
    return directItems;
  }
  function setStep(next) {
    step = next;
    draw();
    panel()?.querySelector('.rp-quote-list-body')?.scrollTo({top:0});
    panel()?.querySelector('#rp-quote-list-title')?.focus({preventScroll:true});
  }
  function updateView(count) {
    const el = panel();
    if (!el) return;
    const form = el.querySelector('[data-rp-list-form]');
    const sent = !!form?.querySelector('[data-submitted="true"]');
    if (!count && !sent) step = 'items';
    const details = step === 'details' && (count > 0 || sent);
    el.querySelector('[data-rp-quote-summary]').hidden = details;
    el.querySelector('[data-rp-quote-empty]').hidden = count > 0;
    el.querySelector('[data-rp-quote-footer]').hidden = !count || details;
    form.hidden = !details;
    el.querySelector('#rp-quote-list-title').textContent = details ? (directItems === null ? config().detailsTitle : config().directTitle) : config().listTitle;
    el.dataset.enquiryMode = directItems === null ? 'quote_list' : 'single_product';
    const context = el.querySelector('[data-rp-enquiry-product]');
    const directNote = el.querySelector('[data-rp-enquiry-saved-list-note]');
    context.hidden = directItems === null || !details || sent;
    directNote.hidden = context.hidden;
    context.textContent = directItems?.map(item => `${item.product_title || item.title}\n${config().partNumberLabel}: ${item.sku || ''} · ${config().quantityLabel}: ${item.quantity}`).join('\n') || '';
    directNote.textContent = config().directNote || ''; 
    el.querySelector('[data-rp-quote-back]').setAttribute('aria-label', details && directItems === null ? config().backLabel : config().closeLabel);
    el.querySelector('[data-rp-quote-selected]').textContent = count === 1 ? config().itemSelected : (config().itemsSelected || 'COUNT').replace('COUNT', count);
    el.querySelector('.rp-quote-review-summary').hidden = sent;
    el.querySelector('.rp-quote-details-heading').hidden = sent;
    el.classList.toggle('rp-quote-details-step', details);
  }
  function icon(name) {
    const source = document.querySelector('#rp-quote-row-icons')?.content.querySelector(`[data-icon="${name}"]`);
    return source ? source.cloneNode(true) : document.createTextNode('');
  }
  function write(change) {
    const commit = () => {
      const next = change(read());
      localStorage.setItem(KEY, JSON.stringify(next));
      const status = panel()?.querySelector('[data-rp-list-error]');
      if (status) status.hidden = true;
      draw();
      document.dispatchEvent(new CustomEvent('rp:quote-change'));
      return next;
    };
    const task = () => navigator.locks ? navigator.locks.request('rp-quote-list-write', commit) : commit();
    queue = queue.then(task, task);
    return queue;
  }
  async function catalog(handle) {
    if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) throw new Error(config().unavailable);
    const response = await fetch(`${root()}products/${encodeURIComponent(handle)}?view=rp-commerce-data`, {headers:{Accept:'text/html'}, cache:'no-store'});
    if (!response.ok) throw new Error(config().unavailable);
    const result = await response.json();
    if (!result.product?.id || !Array.isArray(result.product.variants) || typeof result.direct_purchase !== 'boolean') throw new Error(config().unavailable);
    return result;
  }
  function line(request, product) {
    const variant = product.variants.find(v => Number(v.id) === Number(request.id || request.variant_id));
    const quantity = Number(request.quantity);
    if (!variant || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error(config().unavailable);
    const imageSource = variant.featured_image?.src || product.featured_image || null;
    const image = imageSource?.startsWith('//') ? `https:${imageSource}` : imageSource;
    const price = Number(variant.price);
    return {
      id:Number(variant.id), variant_id:Number(variant.id), product_id:Number(product.id),
      handle:product.handle, quantity, properties:request.properties || {},
      title:product.title, product_title:product.title, variant_title:variant.title,
      sku:variant.sku || '', vendor:product.vendor, product_type:product.type,
      url:`${root()}products/${product.handle}?variant=${variant.id}`,
      image, featured_image: image ? {url:image, alt:product.title} : null,
      price, original_price:price, final_price:price, discounted_price:price,
      line_price:price * quantity, original_line_price:price * quantity, final_line_price:price * quantity,
      total_discount:0, discounts:[], line_level_discount_allocations:[],
      grams:Number(variant.weight || 0), requires_shipping:variant.requires_shipping !== false,
      taxable:variant.taxable !== false, gift_card:false,
      options_with_values:(product.options || []).map((o, i) => ({name:typeof o === 'string' ? o : o.name, value:variant.options?.[i]}))
    };
  }
  async function resolve(requests) {
    const handles = [...new Set(requests.map(item => item.handle))];
    const entries = await Promise.all(handles.map(async handle => [handle, await catalog(handle)]));
    const products = new Map(entries);
    return requests.map(request => ({request, data:products.get(request.handle), item:line(request, products.get(request.handle).product)}));
  }
  async function add(items) {
    directItems = null;
    const next = await write(current => {
      for (const item of items) {
        const index = current.findIndex(existing => keyFor(existing) === keyFor(item));
        const quantity = (index < 0 ? 0 : current[index].quantity) + item.quantity;
        if (quantity > 9999) throw new Error(config().error);
        const next = {...item, quantity};
        if (index < 0) current.push(next); else current[index] = next;
      }
      return current;
    });
    if (items.length) { step = 'items'; open(document.activeElement); }
    return next;
  }
  async function snapshot() {
    const saved = activeItems();
    const hydrated = await resolve(saved);
    const items = hydrated.map(({item}) => ({...item, key:keyFor(item)}));
    const total = items.reduce((sum, item) => sum + item.line_price, 0);
    return {
      note:'', attributes:{rp_enquiry_mode:directItems === null ? 'quote_list' : 'single_product'}, item_count:items.reduce((sum, item) => sum + item.quantity, 0),
      items, total_price:total, original_total_price:total, items_subtotal_price:total,
      total_discount:0, total_weight:items.reduce((sum,item) => sum + item.grams * item.quantity, 0),
      requires_shipping:items.some(item => item.requires_shipping), currency:config().currency || 'AUD', cart_level_discount_applications:[]
    };
  }
  async function complete(items) {
    if (directItems !== null) { directItems = []; draw(); return []; }
    return write(current => current.flatMap(item => {
      const sent = items.find(candidate => keyFor(candidate) === keyFor(item));
      const quantity = item.quantity - (sent?.quantity || 0);
      return quantity > 0 ? [{...item, quantity}] : [];
    }));
  }
  function draw() {
    let items;
    let saved;
    try { saved = read(); items = activeItems(); } catch { error(config().storageError); return; }
    const count = items.reduce((sum,item) => sum + item.quantity, 0);
    const savedCount = saved.reduce((sum,item) => sum + item.quantity, 0);
    document.querySelectorAll('[data-rp-quote-count]').forEach(el => { const shownCount = panel()?.contains(el) ? count : savedCount; el.textContent = shownCount; el.hidden = shownCount === 0; });
    document.querySelectorAll('[data-rp-quote-open]').forEach(el => el.setAttribute('aria-label', `${config().countLabel || 'Quote'}: ${savedCount}`));
    const announcement = document.querySelector('[data-rp-quote-announcement]');
    if (announcement) announcement.textContent = `${config().countLabel || 'Quote'}: ${savedCount}`;
    const container = panel()?.querySelector('[data-rp-quote-items]');
    if (!container) return;
    const focused = container.contains(document.activeElement) ? document.activeElement : null;
    const focusKey = focused?.dataset.rpQuoteKey || focused?.dataset.rpQuoteQuantity || focused?.dataset.rpQuoteRemove;
    const focusType = focused?.dataset.rpQuoteAdjust || (focused?.dataset.rpQuoteRemove ? 'remove' : 'quantity');
    const children = items.map((item, index) => {
      const key = keyFor(item);
      const row = document.createElement('article'); row.className = 'rp-quote-row shadow-1';
      const imageLink = document.createElement(item.handle ? 'a' : 'span'); imageLink.className = 'rp-quote-row-image';
      const href = item.handle ? `${root()}products/${encodeURIComponent(item.handle)}?variant=${item.variant_id}` : null;
      if (href) { imageLink.href = href; imageLink.setAttribute('tabindex', '-1'); imageLink.setAttribute('aria-hidden', 'true'); }
      let imageUrl;
      try { const parsed = new URL(item.image || item.featured_image?.url || '', location.origin); if (parsed.protocol === 'https:' && (item.image || item.featured_image?.url)) imageUrl = parsed.href; } catch {}
      if (imageUrl) {
        const image = document.createElement('img'); image.src = imageUrl; image.alt = ''; image.width = 96; image.height = 96; image.loading = 'lazy'; imageLink.append(image);
      } else imageLink.append(icon('placeholder'));
      const details = document.createElement('div'); details.className = 'rp-quote-row-info';
      const body = document.createElement('div'); body.className = 'rp-quote-row-body';
      const headingRow = document.createElement('div'); headingRow.className = 'rp-quote-row-heading';
      const heading = document.createElement('h3'); heading.className = 'rp-quote-row-title';
      const title = document.createElement(href ? 'a' : 'span');
      title.textContent = item.product_title || item.title;
      if (href) title.href = href;
      heading.append(title); headingRow.append(heading); body.append(headingRow);
      const sku = document.createElement('small');
      sku.textContent = [item.sku, item.variant_title !== 'Default Title' ? item.variant_title : ''].filter(Boolean).join(' · ');
      if (sku.textContent) body.append(sku);
      for (const [name,value] of Object.entries(item.properties)) {
        if (name.startsWith('_') || !value) continue;
        const detail = document.createElement('small'); detail.textContent = `${name}: ${value}`; body.append(detail);
      }
      const controls = document.createElement('div'); controls.className = 'rp-quote-row-quantity';
      const label = document.createElement('label'); label.className = 'visually-hidden'; label.textContent = `${config().quantity}: ${title.textContent}`; label.htmlFor = `rp-quote-quantity-${index}`;
      const input = document.createElement('input'); input.type = 'number'; input.min = '1'; input.max = '9999'; input.step = '1'; input.inputMode = 'numeric'; input.id = label.htmlFor; input.value = item.quantity; input.dataset.rpQuoteQuantity = key; input.disabled = submitting;
      const adjust = (amount, name, text) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'rp-quote-quantity-button'; button.dataset.rpQuoteAdjust = amount; button.dataset.rpQuoteKey = key; button.disabled = submitting || (amount < 0 ? item.quantity <= 1 : item.quantity >= 9999); button.setAttribute('aria-label', `${text}: ${title.textContent}`); button.append(icon(name)); return button;
      };
      controls.append(label, adjust(-1, 'minus', config().decrease), input, adjust(1, 'plus', config().increase));
      details.append(body, controls);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'rp-quote-row-remove'; remove.setAttribute('aria-label', `${config().remove}: ${title.textContent}`); remove.title = config().remove; remove.dataset.rpQuoteRemove = key; remove.disabled = submitting; remove.append(icon('remove'));
      headingRow.append(remove);
      row.append(imageLink, details); return row;
    });
    container.replaceChildren(...children);
    updateRecommendations(items);
    updateView(count);
    if (focusKey && panel()?.open) {
      const target = Array.from(container.querySelectorAll('input,button')).find(el => {
        const key = el.dataset.rpQuoteKey || el.dataset.rpQuoteQuantity || el.dataset.rpQuoteRemove;
        const type = el.dataset.rpQuoteAdjust || (el.dataset.rpQuoteRemove ? 'remove' : 'quantity');
        return key === focusKey && type === focusType && !el.disabled;
      });
      (target || container.querySelector('input') || panel().querySelector('#rp-quote-list-title'))?.focus({preventScroll:true});
    }
  }
  let recommendationsRequest;
  function updateUpsellNavigation(upsells) {
    const list = upsells.querySelector('.rp-quote-upsells-list');
    const navigation = upsells.querySelector('.rp-quote-upsell-navigation');
    const count = list.querySelectorAll('[data-rp-quote-upsell-handle]:not([hidden])').length;
    navigation.hidden = count < 2;
    navigation.querySelector('[data-rp-quote-upsell-step="-1"]').disabled = count < 2 || list.scrollLeft <= 1;
    navigation.querySelector('[data-rp-quote-upsell-step="1"]').disabled = count < 2 || Math.ceil(list.scrollLeft + list.clientWidth) >= list.scrollWidth - 1;
  }
  function updateRecommendations(items) {
    const upsells = panel()?.querySelector('[data-rp-quote-upsells]');
    if (upsells) {
      const selected = new Set(items.map(item => item.handle));
      const limit = Number(upsells.dataset.limit) || 5;
      let visible = 0;
      const list = upsells.querySelector('.rp-quote-upsells-list');
      const previous = Array.from(upsells.querySelectorAll('[data-rp-quote-upsell-handle]:not([hidden])')).map(item => item.dataset.rpQuoteUpsellHandle).join(',');
      upsells.querySelectorAll('[data-rp-quote-upsell-handle]').forEach(item => {
        item.hidden = selected.has(item.dataset.rpQuoteUpsellHandle) || visible >= limit;
        if (!item.hidden) visible += 1;
      });
      upsells.hidden = directItems !== null || !items.length || !visible;
      const current = Array.from(upsells.querySelectorAll('[data-rp-quote-upsell-handle]:not([hidden])')).map(item => item.dataset.rpQuoteUpsellHandle).join(',');
      if (previous !== current) list.scrollLeft = 0;
      if (!list.dataset.navigationBound) {
        list.dataset.navigationBound = 'true';
        const syncNavigation = () => updateUpsellNavigation(upsells);
        list.addEventListener('scroll', syncNavigation, {passive:true});
        if ('ResizeObserver' in window) new ResizeObserver(syncNavigation).observe(list);
      }
      updateUpsellNavigation(upsells);
    }
  }
  function loadRecommendations() {
    const container = panel()?.querySelector('[data-rp-quote-recommendations]');
    if (!container || container.dataset.loaded || recommendationsRequest) return;
    let items;
    try { items = read(); } catch { return; }
    if (!items.length) return;
    recommendationsRequest = fetch(`${root()}?section_id=rp-quote-recommendations`, {headers:{Accept:'text/html'}})
      .then(response => {
        if (!response.ok) throw new Error();
        return response.text();
      })
      .then(html => {
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rp-quote-upsells]');
        if (content) container.replaceChildren(content);
        container.dataset.loaded = 'true';
        updateRecommendations(read());
      })
      .catch(() => {})
      .finally(() => { recommendationsRequest = null; });
  }
  function resetForm() {
    const form = panel()?.querySelector('[data-rp-quote-form]');
    if (!form || form.dataset.submitting === 'true') return;
    delete form.dataset.submitted; form.classList.remove('is-success');
    form.querySelectorAll('input, textarea, button').forEach(field => {field.disabled = false;});
    const fields = form.querySelector('[data-rp-quote-panel]'); fields.inert = false; fields.removeAttribute('aria-hidden');
    form.querySelector('[data-rp-quote-status]').textContent = '';
    panel().querySelector('[data-rp-quote-new]').hidden = true;
    draw();
  }
  async function submitOnce(callback) {
    const run = async lock => {
      if (navigator.locks && !lock || submitting) { error(config().busy); return; }
      submitting = true; draw();
      try { return await callback(); } finally { submitting = false; draw(); }
    };
    return navigator.locks ? navigator.locks.request('rp-quote-submit', {ifAvailable:true}, run) : run(true);
  }
  window.RPQuoteList = {read, resolve, add, snapshot, complete, open, error, submitOnce, resetForm, enquire:async (requests, trigger) => {const hydrated = await resolve(requests); openDirect(hydrated.map(({item}) => item), trigger);}};
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-rp-quote-open]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    if (event.target.closest('[data-rp-quote-close]')) { panel().close(); return; }
    if (event.target.closest('[data-rp-quote-back]')) { if (step === 'details' && directItems === null) setStep('items'); else panel().close(); return; }
    if (event.target.closest('[data-rp-quote-edit]')) { setStep('items'); return; }
    if (event.target.closest('[data-rp-quote-continue]')) { setStep('details'); return; }
    const slide = event.target.closest('[data-rp-quote-upsell-step]');
    if (slide) {
      const list = panel()?.querySelector('.rp-quote-upsells-list');
      list?.scrollBy({left: Number(slide.dataset.rpQuoteUpsellStep) * list.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const adjust = event.target.closest('[data-rp-quote-adjust]');
    if (adjust && !adjust.disabled && !submitting) {
      try { await writeActive(items => items.map(item => keyFor(item) === adjust.dataset.rpQuoteKey ? {...item, quantity:Math.max(1,Math.min(9999,item.quantity + Number(adjust.dataset.rpQuoteAdjust)))} : item)); }
      catch { error(config().storageError); }
      return;
    }
    if (event.target.closest('[data-rp-quote-new]')) { resetForm(); return; }
    const remove = event.target.closest('[data-rp-quote-remove]');
    if (remove && !submitting) {
      try { await writeActive(items => items.filter(item => keyFor(item) !== remove.dataset.rpQuoteRemove)); }
      catch { error(config().storageError); }
      return;
    }
    const button = event.target.closest('[data-rp-quote-add], [data-rp-enquire]');
    if (!button || button.disabled) return;
    event.preventDefault(); button.disabled = true;
    try {
      const form = button.closest('form');
      if (form?.matches('[data-rp-campaign-package]') && !form.reportValidity()) return;
      const data = form ? new FormData(form) : null;
      const quantity = Number(data?.get('quantity') || 1);
      const id = Number(data?.get('id') || button.dataset.rpQuoteVariant);
      const properties = Object.fromEntries([...(data?.entries() || [])].filter(([name]) => name.startsWith('properties[') && name.endsWith(']')).map(([name,value]) => [name.slice(11,-1), String(value)]));
      const [{item}] = await resolve([{id, quantity, handle:button.dataset.rpQuoteHandle, properties}]);
      if (button.hasAttribute('data-rp-enquire')) { openDirect([item], button); }
      else { await add([item]); }
      if (panel()?.querySelector('[data-submitted="true"]')) resetForm();
    } catch(e) { error(e.message || config().error); open(button); }
    finally { button.disabled = false; }
  });
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-rp-quote-quantity]');
    if (!input || submitting) return;
    if (!input.reportValidity()) return;
    const quantity = Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 9999) return;
    try { await writeActive(items => items.map(item => keyFor(item) === input.dataset.rpQuoteQuantity ? {...item,quantity} : item)); }
    catch { error(config().storageError); }
  });
  window.addEventListener('storage', event => {if (event.key === KEY || event.key === null) draw();});
  window.addEventListener('pageshow', draw);
  const init = () => {
    panel()?.addEventListener('click', event => {
      if (event.target !== panel()) return;
      const bounds = panel().getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) panel().close();
    });
    document.addEventListener('modal:open', event => {
      if (event.detail?.data?.stash === 'cart-drawer' && panel()?.open) panel().close();
    });
    panel()?.addEventListener('close', () => {
      directItems = null;
      document.documentElement.classList.remove('rp-quote-drawer-open');
      document.querySelectorAll('[data-rp-quote-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      opener?.focus?.();
    });
    draw();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();



